import { AxiosResponse } from 'axios';
import { BaseService } from './base.service';
import { User } from '../models/user.models';
import { GetAllStatsPayload } from '../models/service.models';
import { StatsResponse } from '../models/stats.models';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export default class AnalyticsService extends BaseService {
  private readonly _analyticsUrl = 'stats';

  public async getAllStats(payload: GetAllStatsPayload) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    return this.axios.post(`${this.backendUrl}/${this._analyticsUrl}`, payload, {
      headers: {
        'Time-Zone': dayjs.tz.guess(),
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async getAnalyticsForTeam(teamId: string, date: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    const params = new URLSearchParams({
      date,
    }).toString();
    return this.axios.get(`${this.backendUrl}/teams/${teamId}/analytics?${params}`, {
      headers: {
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async getAnalyticsDashboard() {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    return this.axios.get(`${this.backendUrl}/analytics`, {
      headers: {
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async getTeamDashboard(teamId) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    return this.axios.get(`${this.backendUrl}/analytics/team/${teamId}`, {
      headers: {
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async getAnalyticsAnnualStartDate() {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.get(`${this.backendUrl}/annual-start-date`, {
      headers: {
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async updateAnalyticsAnnualStartDate(annualStartDate: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.put(
      `${this.backendUrl}/annual-start-date`,
      { annual_start_date: annualStartDate },
      {
        headers: {
          'x-access-token': user.token,
          'Measurement-System': user.measurementSystem,
        },
      }
    );
  }

  public async getStats(start: string, end: string): Promise<AxiosResponse<{ data: StatsResponse }>> {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.post(
      `${this.backendUrl}/stats`,
      {
        start,
        end,
      },
      {
        headers: {
          'x-access-token': user.token,
          'Measurement-System': user.measurementSystem,
        },
      }
    );
  }
}
